import { Component } from 'react';
import { List } from 'devextreme-react';
import Accordion from 'devextreme-react/accordion';
import * as Fnctn from '../../contexts/GenericFunctions';
import ItemRenderdtList from '../../pages/LibretaTareas/EditarCurso/CoursesItems';
import { ItemDragging } from 'devextreme-react/list';
import { set_tarea_id } from '../../reduxStore/LibretaTareas/LB_actions';
import { halcoloaderActive, halcoloaderRemove } from '../../contexts/HalcoLoader';

interface IProps {
}
interface IState {
    Courses: any,
    Classes: any,
    CourseIndex: any
}
class Courses extends Component<IProps, IState> {
    constructor(props: IProps) {
        super(props);
        this.state = {
            Courses: [],
            Classes: [],
            CourseIndex: -1
        }
    }

    componentDidMount() {
        this.getCourses();
    }

    getCourses = async () => {
        halcoloaderActive();

        const dtresult:any = await Fnctn.postData(`/catalogs/courses/?onboarding=false`, "GET", {});
        const dtCourses = await dtresult.json();
        const sortedItems = await [...dtCourses.data[0]].sort((a, b) => a.order - b.order);
        this.setState({ Courses: sortedItems });
        halcoloaderRemove();
    }

    ItemRenderAccordion = (item: any) => {
        return (
            <div className='listCategoriesContent'>
                <img src={item.img_path} alt='Imagen de curso' className='ImgCategories' />
                <label className='lbTitleCategories'>{item.name}</label>
            </div>
        )
    }

    getClasses = async (items: any) => {
        halcoloaderActive();
        this.setState({ Classes: [] });
        const dtresult:any = await Fnctn.postData("/training/task", "GET", {});

        const dtClasses = await dtresult.json();
        const DataClasses = dtClasses.data.filter((item: any) => item.category_id == items.itemData._id);
        const sortedItems = [...DataClasses].sort((a, b) => a.order - b.order);
        this.setState({ Classes: sortedItems });
        halcoloaderRemove();
    }

    nav = async (navigate: any, dispatch: any, idTarea: string) => {
        dispatch(set_tarea_id(idTarea))
        await navigate('/courses')
    }

    deleteClasses = async (classId: any) => {
        this.setState(prevState => ({
            Classes: prevState.Classes.filter((classItem: any) => classItem._id !== classId)
        }));
    }

    onDragStart = (e: any) => { 
        e.itemData = this.state.Classes[e.fromIndex]
    }

    onAdd = async (e: any) => {
        const classes = this.state.Classes
        const updatedClasses = [...classes.slice(0, e.toIndex), e.itemData, ...classes.slice(e.toIndex)];
        for (let i: number = 0; i < updatedClasses.length; i++) {
            updatedClasses[i].order = i
        }

        updatedClasses.forEach(async (element: any) => {
            let Objt = { "order": element.order }
            await Fnctn.postData(`/training/task/${element._id}`, "PUT", Objt);
        });
        await this.setState({ Classes: updatedClasses })
    }

    onRemove = async (e: any) => {
        const classes = this.state.Classes
        const updatedclasses = [...classes.slice(0, e.fromIndex), ...classes.slice(e.fromIndex + 1)];
        await this.setState({ Classes: updatedclasses })

    }

    onReorder = async (e: any) => {
        await this.onRemove(e);
        await this.onAdd(e);
    }

    ItemRender = () => {
        return (
            <div>
                <List
                    dataSource={this.state.Classes}
                    height={400}
                    selectionMode={"none"}
                    displayExpr={"name"}
                    keyExpr={"_id"}
                    itemComponent={(prop: any) => <div><ItemRenderdtList data={prop.data} deleteCourse={this.deleteClasses} /></div>}
                >
                    <ItemDragging
                        allowReordering={true}
                        onDragStart={(e) => this.onDragStart(e)}
                        onAdd={(e) => this.onAdd(e)}
                        onRemove={(e) => this.onRemove(e)}
                        onReorder={(e) => this.onReorder(e)}
                    ></ItemDragging>
                </List>
            </div>
        )
    }

    ChangeIndex = (items:any) => {
        const index = items.component.option('selectedIndex');
        this.setState({CourseIndex: items.addedItems.length <= 0 ? -1 : index })
    }

    render() {
        return (
            <div>
                <Accordion
                    selectedIndex={this.state.CourseIndex}
                    className='AccordionCourses'
                    dataSource={this.state.Courses}
                    animationDuration={270}
                    collapsible={true}
                    itemRender={this.ItemRender}
                    itemTitleRender={(e) => this.ItemRenderAccordion(e)}
                    onItemTitleClick={(e) => { this.getClasses(e); }}
                    onSelectionChanged={(e: any) => this.ChangeIndex(e)}
                />
            </div>
        );
    }
}


export default Courses;